"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapActionConfigItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const map_actions_config_1 = require("../../utils/map-actions-config");
class MapActionConfigItemDto {}
exports.MapActionConfigItemDto = MapActionConfigItemDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: map_actions_config_1.MapActionKey,
  description: 'Stable sidebar action id on the new map.'
}), __metadata("design:type", String)], MapActionConfigItemDto.prototype, "key", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Sidebar tooltip / accessibility name.'
}), __metadata("design:type", String)], MapActionConfigItemDto.prototype, "label", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Text of the pill shown at the bottom of the map while the filter is selected.'
}), __metadata("design:type", String)], MapActionConfigItemDto.prototype, "badgeText", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Marker badge and pill dot color (#RRGGBB).'
}), __metadata("design:type", String)], MapActionConfigItemDto.prototype, "color", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Catalog icon name (Heroicons outline, e.g. "fire"); null = the built-in icon. Unknown to the app build = built-in.'
}), __metadata("design:type", Object)], MapActionConfigItemDto.prototype, "iconName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Uploaded SVG icon URL (tinted by the app); wins over iconName.'
}), __metadata("design:type", Object)], MapActionConfigItemDto.prototype, "iconUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: map_actions_config_1.MapActionState,
  description: 'Active = selectable; Disabled = shown dimmed; Hidden = not shown.'
}), __metadata("design:type", String)], MapActionConfigItemDto.prototype, "state", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Toast shown when a disabled filter is tapped; empty = no toast.'
}), __metadata("design:type", String)], MapActionConfigItemDto.prototype, "disabledMessage", void 0);
//# sourceMappingURL=MapActionConfigItem.dto.js.map